import style_inject_es_default from "../../../../../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js";

//#region src/components/toggle-button/toggle-button.module.css
var css_248z = ".toggle-button-module_root__N6U-N {\n    :where([data-mantine-color-scheme='light'])\n        &:where(\n            :disabled:not([data-loading]),\n            [data-disabled]:not([data-loading])\n        ) {\n        background-color: var(--ai-bg);\n    }\n\n    cursor: var(--toggle-button-cursor, pointer);\n}\n";
var toggle_button_module_default = { "root": "toggle-button-module_root__N6U-N" };
style_inject_es_default(css_248z);

//#endregion
export { toggle_button_module_default as default };